module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-logo"
  }, [_c('div', {
    staticClass: "main-width set-position"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/logo@1x.png",
      "width": "253px",
      "height": "54px",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticClass: "row-logo-right2"
  }, [_vm._v("建议使用谷歌浏览器，如需技术帮助，可咨询以下QQ:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "row-logo-right2"
  }, [_vm._v("咨询QQ： 2864465221")]), _vm._v("\n        \n      "), _c('span', {
    staticClass: "row-logo-right2"
  }, [_vm._v("1227370263")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "row-logo-right2"
  }, [_vm._v("供应商操作视频链接：  http://pan.baidu.com/s/1eSsYnXg")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "row-logo-right2"
  }, [_vm._v("如需业务帮助，请咨询联系招标的业务人员.")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group pull-right hidden"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "搜索商机/物资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/search.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78ca7810!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-logo.vue
// module id = 25
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15